export type GuestValidationInputData = {
  guest_token: string;
  dob: string;
};

export type LoginValidationInputData = {
  guest_token: string;
};

export type GuestValidationResponseData = {
  access_token: string;
  link_type: LinkType;
  paymentRequestId?: string;
  paymentPlanId?: string;
  receiptId?: string;
};

export type LoginValidationResponseData = {
  access_token: string;
  link_type: LinkType;
  paymentRequestId?: string;
  paymentPlanId?: string;
  receiptId?: string;
};

export type UpdatePaymentPlanInput = {
  setupIntentId: string;
  paymentPlanId: string;
};

export type CreatePaymentMethodInput = {
  patientUid: string;
};

export type CreatePaymentPlanInput = {
  numberOfInstallments: number;
};

export type ConfirmPaymentInput = {
  paymentIntentId: string;
};

export type ConfirmPaymentPlanInput = {
  setupIntentId: string;
};

export type ConfirmPaymentPlanResponseData = {
  paymentPlanId: string;
};

export type CreatePaymentMethodResponseData = {
  clientSecret: string;
  customerSessionSecret: string;
};

export type PaymentRequestResponseData = {
  patientUid: string;
  paymentRequestId: string;
  status: PaymentStatus;
  totalAmountCents: number;
  currency: string;
  lineItems: LineItem[];
  enablePaymentPlan?: boolean;
};

export type LineItem = {
  orderUid: string;
  name: string;
  lineItemUid: string;
  caseId: string;
  amountCents: number;
  expirationDate: string;
  dateOfService: string;
  orderedBy: string;
};

export type PaymentPlanRequestResponseData = {
  paymentPlanId: string;
  paymentMethodSummary: string;
  createdAt: string;
  currentInstallmentIndex: number;
  numberOfInstallments: number;
  patientUid: string;
  lineItems: PaymentPlanLineItem[];
  stripePaymentMethodId: string;
  updatePaymentMethodURL?: string;
  planStartDate: string;
  status: PaymentPlanStatus;
  stripeSubscriptionId: string;
  installmentDetails: InstallmentDetail[];
  totalAmountCents: number;
  paidAmountCents: number;
  remainingAmountCents: number;
  updatedAt: string;
  cancelReason?: string;
};

export type InstallmentDetail = {
  amountCents: number;
  currency: string;
  dueDate: string;
  paidDate?: string;
  installmentIndex: number;
  paymentIntentId?: string;
  stripePriceId: string;
  status: InstallmentStatus;
  failureCode?: string;
  failureMessage?: string;
  attemptCount?: number;
};

export type PaymentPlanLineItem = {
  lineItemUid: string;
  orderId: string;
  caseId: string;
  testName: string;
  amounts: InstallmentAmount[];
};

export type InstallmentAmount = {
  installmentIndex: number;
  amountCents: number;
};

export type CalculateLineItem = {
  name: string;
  price: number;
};

export type CalculateInstallmentRequestData = {
  lineItems: CalculateLineItem[];
  numberOfInstallment: number;
};

export type CalculateInstallmentResponseData = {
  amount: number;
  indexes: number[];
};

export type ResponseData<T = void> = {
  message: string;
  data?: T;
  error?: UPSErrors;
};

export type RedirectionMap = {
  [key in string]: string;
};

export enum PaymentPlanStatus {
  ACTIVE = "ACTIVE",
  CANCELLED = "CANCELLED",
  FAILED = "FAILED",
  COMPLETED = "COMPLETED",
  ERROR = "ERROR",
}

export enum InstallmentStatus {
  PAID = "paid",
  UNPAID = "unpaid",
  FAILED = "failed",
}

export enum LinkType {
  PAYMENT_REQUEST = "paymentRequest",
  UPDATE_PAYMENT = "updatePayment",
  RECEIPT = "receipt",
}

export enum PaymentStatus {
  DRAFT = "DRAFT",
  PROCESSING = "PROCESSING",
  PAID = "PAID",
  EXPIRED = "EXPIRED",
  FAILED = "FAILED",
  DELETED = "DELETED",
}

export enum UPSErrors {
  INTERNAL_SERVER_ERROR = "INTERNAL_SERVER_ERROR",
  PATIENT_NOT_FOUND = "PATIENT_NOT_FOUND",
  PATIENT_UID_NOT_MATCHED = "PATIENT_UID_NOT_MATCHED",
  ORDER_NOT_FOUND = "ORDER_NOT_FOUND",
  INCORRECT_DOB = "INCORRECT_DOB",
  TOKEN_EXPIRED = "TOKEN_EXPIRED",
}
